import React, { useEffect, useRef, useState } from 'react';
import CustomEvent from './CustomEvent';
import { useDispatch, useSelector } from 'react-redux';
import { setActivities } from '../Store/entities/book';
import { changeAssignedDate } from '../Store/api/activities';
import cross from '../assets/images/cross-gray.svg';
import { toast } from 'react-toastify';
const currentDate = new Date();

const year = currentDate.getFullYear().toString().slice(-2);
const formattedDate = `${currentDate.toLocaleString('default', {
  month: 'short',
})} ‘${year}`;
const CustomCell = ({
  value,
  isDragging,
  setIsDragging,
  draggedEvent,
  setDraggedEvent,
  position,
  setPosition,
  setDraggedOverDate,
  draggedOverDate,
  isDraggingActivity,
  draggedActivity,
  // setActivities,
  setSelectedActivity,
  selectedActivity,
}) => {
  const dispatch = useDispatch();
  const { book } = useSelector((state) => state.entities);
  const [isExpanded, setIsExpaned] = useState(false);
  const [isMoreTextHovered, setIsMoreTextHovered] = useState(false);
  const fullModelRef = useRef(null);
  const classes = useSelector((state) => state.entities.classes);
  const [classSectionIds, setClassSectionIds] = useState([]);
  const isToday = currentDate.getDate() === value.getDate() && currentDate.getMonth() === value.getMonth() && currentDate.getFullYear() === value.getFullYear();
  const spacialDays = [1, 3, 5];

  /* Class and Section */

  useEffect(() => {
    // Check if classes exist and map through each class and section
    if (classes?.classes?.length) {
      const ids = classes.classes.map((classItem) => {
        return classItem.sections?.map((sectionItem) => ({
          classId: sectionItem?.classId,
          sectionId: sectionItem?._id,
        }));
      });

      // Flatten the array and filter out any undefined values
      const flattenedIds = ids.flat().filter(Boolean);

      // Update state
      setClassSectionIds(flattenedIds);
    }
  }, [classes?.classes]);

  /* --------------------- */
  const dateEvents = book.activities.filter((e) => e.assigned && new Date(e.assignedDate).getDate() === value.getDate() && new Date(e.assignedDate).getMonth() === value.getMonth() && new Date(e.assignedDate).getFullYear() === value.getFullYear());

  const dropEvent = (e) => {
    const newActs = JSON.parse(JSON.stringify(book.activities));
    if (isDragging && draggedEvent) {
      dispatch(
        changeAssignedDate({
          id: draggedEvent._id,
          body: {
            assignedDate: value.toISOString(),
            classId: classSectionIds[0]?.classId,
            sectionId: classSectionIds[0]?.sectionId,
          },
          onSuccess: (res) => {
            dispatch(
              setActivities(
                newActs.map((activity) => {
                  if (activity._id === draggedEvent._id) {
                    activity.assignedDate = value.toISOString();
                    activity.assigned = true;
                  }
                  return activity;
                })
              )
            );
          },
          onError: (error) => {
            toast.error(error?.response?.data?.message);
          },
        })
      );
    } else if (isDraggingActivity && draggedActivity) {
      dispatch(
        changeAssignedDate({
          id: draggedActivity._id,
          body: {
            assignedDate: value.toISOString(),
            classId: classSectionIds[0]?.classId,
            sectionId: classSectionIds[0]?.sectionId,
          },
          onSuccess: (res) => {
            dispatch(
              setActivities(
                newActs.map((activity) => {
                  if (activity._id === draggedActivity._id) {
                    activity.assignedDate = value.toISOString();
                    activity.assigned = true;
                  }
                  return activity;
                })
              )
            );
          },
          onError: (error) => {
            toast.error(error?.response?.data?.message);
          },
        })
      );
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (fullModelRef.current && !fullModelRef.current.contains(event.target)) {
        // Click is outside of element x and not on elements with class 'y'
        // Execute your statement here
        setIsExpaned(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  // Add your custom cell rendering logic here
  return (
    <div
      className={`custom-cell`}
      style={{
        background: `${spacialDays.includes(value.getDay()) && 'linear-gradient(0deg, #FAFAF9, #FAFAF9)'}`,
        cursor: `${isDragging || isDraggingActivity ? 'move' : ''}`,
      }}
      onMouseMove={(e) => {
        if ((isDragging && draggedEvent && !dateEvents.includes(draggedEvent)) || (isDraggingActivity && draggedActivity)) {
          setDraggedOverDate(value);
        } else if (isDragging && draggedEvent && dateEvents.includes(draggedEvent)) {
          setDraggedOverDate(null);
        }
      }}
      onMouseUp={dropEvent}
    >
      {/* Ensure key is unique */}
      <div key={`day-${value.toISOString()}`} className={`day ${isToday ? 'current' : ''}`}>
        {value.getDate()}
      </div>
      <div className='cell-body-wrapper'>
        {dateEvents.slice(0, 4).map((event, index) => (
          <CustomEvent
            key={event.id || `event-${index}`} // Ensure a unique key for each CustomEvent
            event={event}
            index={index}
            setPosition={setPosition}
            position={position}
            isDragging={isDragging}
            setIsDragging={setIsDragging}
            setDraggedEvent={setDraggedEvent}
            draggedEvent={draggedEvent}
            setActivities={setActivities}
            setSelectedActivity={setSelectedActivity}
            selectedActivity={selectedActivity}
          />
        ))}
        {(isDragging || isDraggingActivity) && draggedOverDate && draggedOverDate.getDate() === value.getDate() && draggedOverDate.getMonth() === value.getMonth() && draggedOverDate.getFullYear() === value.getFullYear() && <div key={`event-catcher-${value.toISOString()}`} className={`event-catcher ${1 && 'assigned-catcher'}`}></div>}
        {!isExpanded && dateEvents.length > 4 && (!draggedOverDate || draggedOverDate.getDate() !== value.getDate() || (!isDragging && !isDraggingActivity)) && (
          <span
            key={`events-more-${value.toISOString()}`} // Ensure a unique key for each span
            className='events-more cursor'
            onClick={(e) => {
              e.stopPropagation();
              setIsMoreTextHovered(false);
              setIsExpaned(true);
            }}
            onMouseEnter={() => setIsMoreTextHovered(true)}
            onMouseLeave={() => setIsMoreTextHovered(false)}
          >
            {isMoreTextHovered ? (
              <span className='dark'>
                See {dateEvents.length - 4} more {dateEvents.length - 4 > 1 ? 'activities ->' : 'activity ->'}{' '}
              </span>
            ) : (
              <span>+{dateEvents.length - 4} more...</span>
            )}
          </span>
        )}
      </div>
      {isExpanded && (
        <div className='full-modal' ref={fullModelRef}>
          <div className='modal-heading'>
            <span className='text'>Additional activities</span>
            <img
              src={cross}
              alt=''
              className='cross cursor'
              onClick={(e) => {
                e.stopPropagation();
                setIsExpaned(false);
              }}
            />
          </div>

          {dateEvents.map((event, index) => (
            <CustomEvent
              key={event.id || `expanded-event-${index}`} // Unique key for each CustomEvent in expanded mode
              event={event}
              setPosition={setPosition}
              position={position}
              isDragging={isDragging}
              setIsDragging={setIsDragging}
              setDraggedEvent={setDraggedEvent}
              draggedEvent={draggedEvent}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomCell;
